export default __webpack_public_path__ + "static/media/control-rooms-v4.a348055b.jpg";